module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-10 grid"
  }, [_c('div', {
    staticClass: "grid",
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.category), function(c, index) {
    return (_vm.category.length) ? _c('div', {
      staticClass: "col-xs-12 col-lg-4 grid-item p-5"
    }, [_c('div', {
      staticClass: "col-xs-12 card"
    }, [_c('div', {
      staticClass: "col-xs-12 card-title text-left p-x-15"
    }, [_c('span', {
      staticClass: "pull-left"
    }, [_vm._v(_vm._s(c.name))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 text-left"
    }, [_c('ul', {
      staticClass: "nav p-x-15"
    }, _vm._l((c.product_list), function(p, index) {
      return _c('li', {
        staticClass: "card-product c-pointer",
        on: {
          "click": function($event) {
            return _vm.openCombineModal('info', p.name, p.product_id)
          }
        }
      }, [_c('div', {
        staticClass: "product-name inline-block"
      }, [_vm._v(_vm._s(p.name))]), _vm._v(" "), _c('div', {
        staticClass: "inline-block"
      })])
    }), 0)])])]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('ul', {
    staticClass: "pagination"
  }, [(_vm.pageAmount > 1 && _vm.pageGroup !== 1) ? _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        _vm.pageGroup = _vm.pageGroup - 1
      }
    }
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pageAmount), function(index) {
    return (_vm.pageShow(index)) ? _c('li', {
      staticClass: "paginate_button",
      class: {
        active: _vm.isActive(index)
      },
      on: {
        "click": function($event) {
          return _vm.getMenuCategory(index)
        }
      }
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v(_vm._s(index))])]) : _vm._e()
  }), _vm._v(" "), (_vm.pageAmount > 1 && _vm.pageAmount / _vm.groupAmount > _vm.pageGroup) ? _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        _vm.pageGroup = _vm.pageGroup + 1
      }
    }
  }, [_vm._m(2)]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.gotoFrom
    }
  }, [_vm._v("\n      上一步\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.gotoNext
    }
  }, [_vm._v("\n      離開\n    ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('combine-price-modal', {
    attrs: {
      "modalId": "crCombineModal",
      "state": 1,
      "productId": _vm.current.productId,
      "productName": _vm.current.productName,
      "type": _vm.current.type
    }
  }), _vm._v(" "), _c('combine-price-modal', {
    attrs: {
      "modalId": "infoCombineModal",
      "state": 3,
      "productId": _vm.current.productId,
      "productName": _vm.current.productName,
      "type": _vm.current.type
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "inline-block pull-left"
  }, [_c('h4', {
    staticClass: "pull-left"
  }, [_vm._v("\n        商品與組合價格\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-left",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15a78b55"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Menu/Temp/CrCombinationPriceTemp.vue
// module id = 2332
// module chunks = 1